var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Password eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4848 10.0482C19.9193 10.6165 19.9193 11.3838 19.4848 11.9512C18.1162 13.7378 14.8327 17.4163 10.9992 17.4163C7.16574 17.4163 3.88224 13.7378 2.51365 11.9512C2.30226 11.679 2.1875 11.3443 2.1875 10.9997C2.1875 10.6551 2.30226 10.3203 2.51365 10.0482C3.88224 8.26159 7.16574 4.58301 10.9992 4.58301C14.8327 4.58301 18.1162 8.26159 19.4848 10.0482V10.0482Z",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 13.7495C12.5188 13.7495 13.75 12.5183 13.75 10.9995C13.75 9.48073 12.5188 8.24951 11 8.24951C9.48122 8.24951 8.25 9.48073 8.25 10.9995C8.25 12.5183 9.48122 13.7495 11 13.7495Z",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEye);
export default __webpack_public_path__ + "static/media/Password_eye.1989f93186a39121c4b0e3b930fac5d5.svg";
export { ForwardRef as ReactComponent };